import RiceStockRoute from "./RiceStockRoute";

const routes = [
    new RiceStockRoute()
]

export default routes
